export const TELEGRAM_URL = 'https://t.me/Best_Wallet_Official'
export const DISCORD_URL = 'https://discord.com/invite/3zUV8u6u4H'
export const TWITTER_URL = 'https://twitter.com/bestwallethq'
export const LINK_TREE_URL = 'https://linktr.ee/bestwalletofficial'
export const INSTAGRAM_URL = 'https://www.instagram.com/bestwallethq/'
